export const drillDownFields = {
  AGENCY_NAME: "AgencyName",
  PRODUCER_1_NAME: "ProducerName1",
  PRODUCER_2_NAME: "ProducerName2",
  PRODUCER_1_CODE: "ProducerCode1",
  PRODUCER_2_CODE: "ProducerCode2",
};

export const drillDownSortFieldOptions = [
  { label: "Agency", value: drillDownFields.AGENCY_NAME },
  { label: "Producer 1", value: drillDownFields.PRODUCER_1_CODE },
  { label: "Producer 2", value: drillDownFields.PRODUCER_2_CODE },
];
